import React, {useEffect, useState} from 'react';

import styled from 'styled-components';
import {fadeIn, fadeIn2, fadeIn4} from "../../../styled/StyledComponent";

interface ContentsProps {
  children: React.ReactElement;
  filter:boolean
}
const Overlay:React.FC<ContentsProps> = (props) => {
    const [render, setRender] = useState(false);

    useEffect(() => {
        setTimeout(()=>{
            setRender(true);
        },100)

        return () => {
            setRender(
                false
            )
        }
    }, []);

return(
  <Container className={"overlay"}>
    <div className={`${render ? "isActive" : ""} inner`}>
        {props.children}
    </div>

    <OverlayItem
        className={`${props.filter ? "on" : "off"}` }></OverlayItem>
  </Container>
)

}
export { Overlay };

const Container = styled.div`
    //animation: ${fadeIn4} 0.4s linear;
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 99999999;
    background: #33333360;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    top: 0;
    transition: all 0.3s;
    .inner{
        @media screen and (max-width: 768px) {
            @supports (-webkit-touch-callout: none) {
                /* Safari 스타일 */
                padding-top: 20px;
            }
        }
        transition: all 0.3s;
        transform: translateY(16px);
        opacity: 0;
        &.isActive{
            transform: none;
            opacity: 1;
        }
    }
    @media screen and (max-width: 768px) {
        @supports (-webkit-touch-callout: none) {
            /* Safari 스타일 */
            align-items: flex-start;
        }
    }
`;
const OverlayItem = styled.div`
    transition: all 0.3s;
  &.on{
    backdrop-filter: blur(3px);
  }
    
    z-index: -1;
    background: #33333360;
    position: absolute;
    width: 100vw;
    height: 100vh;
`; 
